import { useRef } from 'react';

export const useScrollIntoView = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollIntoView = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return { scrollRef, scrollIntoView };
};
